module.exports = __webpack_public_path__ + "img/gallery.fcf6b56c.svg";